import { useSelector } from "react-redux";
import {
    getNotificationShowedToasts,
    getShowedMessage,
    getShowMessagesQueueLength
} from "../../modules/Notifications/notificationsSelectors";
import { useMemo } from "react";
import { LOCATION_COMPONENTS_SEARCH_PARAMS } from "../../modules/Location/locationConstants";
import { useLocation } from "react-router-dom";

function useIsOverlayComponentsOpened() {
    const showMessagesQueueLength = useSelector(getShowMessagesQueueLength);
    const showedMessage = useSelector(getShowedMessage);
    const showedToasts = useSelector(getNotificationShowedToasts);
    const location = useLocation();

    const isOverlayLocationComponentsOpened = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE).length > 0 || params.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL).length > 0;
    }, [location]);

    return isOverlayLocationComponentsOpened || showMessagesQueueLength > 0 || !!showedMessage || showedToasts.length > 0;
}

export default useIsOverlayComponentsOpened;
